import { useRef, useState, useEffect, useCallback } from "react";
import { Canvas, FabricImage, Textbox, Rect, Path } from "fabric";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import {
  Type, Upload, Trash2, FlipHorizontal, FlipVertical,
  Layers, Move, MousePointer, RotateCw
} from "lucide-react";

/* ── Garment SVG paths (0-100 viewbox) ── */
/* Each garment has front/back views + side profiles */
const GARMENT_PATHS = {
  tshirt: {
    front: "M 25,18 Q 22,18 15,22 L 8,35 L 18,38 L 22,28 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,28 L 82,38 L 92,35 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    back: "M 25,18 Q 22,18 15,22 L 8,35 L 18,38 L 22,28 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,28 L 82,38 L 92,35 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    left_side: "M 38,16 Q 35,16 32,18 L 20,32 L 28,34 L 32,26 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
    right_side: "M 38,16 Q 35,16 32,18 L 20,32 L 28,34 L 32,26 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
  },
  hoodie: {
    front: "M 22,20 Q 18,20 10,24 L 2,40 L 14,44 L 18,30 L 18,82 Q 18,86 24,86 L 76,86 Q 82,86 82,82 L 82,30 L 86,44 L 98,40 L 90,24 Q 82,20 78,20 Q 72,20 64,18 L 62,12 Q 56,8 50,8 Q 44,8 38,12 L 36,18 Q 28,20 22,20 Z",
    back: "M 22,20 Q 18,20 10,24 L 2,40 L 14,44 L 18,30 L 18,82 Q 18,86 24,86 L 76,86 Q 82,86 82,82 L 82,30 L 86,44 L 98,40 L 90,24 Q 82,20 78,20 Q 72,20 64,18 L 62,12 Q 56,8 50,8 Q 44,8 38,12 L 36,18 Q 28,20 22,20 Z",
    left_side: "M 36,12 Q 32,14 28,18 L 16,36 L 24,38 L 28,28 L 30,82 Q 30,86 36,86 L 64,86 Q 70,86 70,82 L 70,28 Q 72,18 68,14 Q 62,10 50,8 Q 44,8 36,12 Z",
    right_side: "M 36,12 Q 32,14 28,18 L 16,36 L 24,38 L 28,28 L 30,82 Q 30,86 36,86 L 64,86 Q 70,86 70,82 L 70,28 Q 72,18 68,14 Q 62,10 50,8 Q 44,8 36,12 Z",
  },
  tank: {
    front: "M 30,16 L 28,18 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 72,18 L 70,16 Q 64,14 58,12 Q 54,11 50,11 Q 46,11 42,12 Q 36,14 30,16 Z",
    back: "M 30,16 L 28,18 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 72,18 L 70,16 Q 64,14 58,12 Q 54,11 50,11 Q 46,11 42,12 Q 36,14 30,16 Z",
    left_side: "M 36,14 L 34,16 L 30,78 Q 30,82 36,82 L 64,82 Q 70,82 70,78 L 66,16 L 64,14 Q 58,11 50,11 Q 42,11 36,14 Z",
    right_side: "M 36,14 L 34,16 L 30,78 Q 30,82 36,82 L 64,82 Q 70,82 70,78 L 66,16 L 64,14 Q 58,11 50,11 Q 42,11 36,14 Z",
  },
  longsleeve: {
    front: "M 25,18 Q 22,18 15,22 L 4,55 L 14,58 L 22,30 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,30 L 86,58 L 96,55 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    back: "M 25,18 Q 22,18 15,22 L 4,55 L 14,58 L 22,30 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,30 L 86,58 L 96,55 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    left_side: "M 38,16 Q 34,18 30,22 L 18,50 L 26,52 L 32,30 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
    right_side: "M 38,16 Q 34,18 30,22 L 18,50 L 26,52 L 32,30 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
  },
  polo: {
    front: "M 25,18 Q 22,18 15,22 L 8,35 L 18,38 L 22,28 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,28 L 82,38 L 92,35 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    back: "M 25,18 Q 22,18 15,22 L 8,35 L 18,38 L 22,28 L 22,78 Q 22,82 28,82 L 72,82 Q 78,82 78,78 L 78,28 L 82,38 L 92,35 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    left_side: "M 38,16 Q 35,16 32,18 L 20,32 L 28,34 L 32,26 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
    right_side: "M 38,16 Q 35,16 32,18 L 20,32 L 28,34 L 32,26 L 34,78 Q 34,82 38,82 L 62,82 Q 66,82 66,78 L 66,26 Q 68,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Z",
  },
  crewneck: {
    front: "M 25,18 Q 22,18 15,22 L 4,50 L 14,53 L 22,30 L 22,82 Q 22,86 28,86 L 72,86 Q 78,86 78,82 L 78,30 L 86,53 L 96,50 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    back: "M 25,18 Q 22,18 15,22 L 4,50 L 14,53 L 22,30 L 22,82 Q 22,86 28,86 L 72,86 Q 78,86 78,82 L 78,30 L 86,53 L 96,50 L 85,22 Q 78,18 75,18 Q 70,18 62,16 Q 56,14 50,14 Q 44,14 38,16 Q 30,18 25,18 Z",
    left_side: "M 38,16 Q 34,18 28,22 L 16,46 L 24,48 L 30,28 L 32,82 Q 32,86 38,86 L 62,86 Q 68,86 68,82 L 68,28 Q 70,18 64,16 Q 58,14 50,14 Q 44,14 38,16 Z",
    right_side: "M 38,16 Q 34,18 28,22 L 16,46 L 24,48 L 30,28 L 32,82 Q 32,86 38,86 L 62,86 Q 68,86 68,82 L 68,28 Q 70,18 64,16 Q 58,14 50,14 Q 44,14 38,16 Z",
  },
  hat: {
    front: "M 15,55 Q 15,35 30,25 Q 40,18 50,18 Q 60,18 70,25 Q 85,35 85,55 L 85,60 Q 50,62 15,60 Z",
    back: "M 15,55 Q 15,35 30,25 Q 40,18 50,18 Q 60,18 70,25 Q 85,35 85,55 L 85,60 Q 50,62 15,60 Z",
    left_side: "M 25,55 Q 25,35 38,25 Q 44,20 50,20 Q 56,20 62,25 Q 75,35 75,55 L 75,60 Q 50,62 25,60 Z",
    right_side: "M 25,55 Q 25,35 38,25 Q 44,20 50,20 Q 56,20 62,25 Q 75,35 75,55 L 75,60 Q 50,62 25,60 Z",
  },
};

/* ── Print area per side (percentage of garment bounding box) ── */
const PRINT_AREAS = {
  front:      { x: 0.30, y: 0.30, w: 0.40, h: 0.42, label: "Front" },
  back:       { x: 0.30, y: 0.30, w: 0.40, h: 0.42, label: "Back" },
  left_side:  { x: 0.30, y: 0.28, w: 0.35, h: 0.40, label: "Left Side" },
  right_side: { x: 0.35, y: 0.28, w: 0.35, h: 0.40, label: "Right Side" },
};

const FONTS = [
  "Arial", "Helvetica", "Georgia", "Times New Roman", "Courier New",
  "Impact", "Verdana", "Trebuchet MS", "Comic Sans MS", "Palatino",
];

const DesignCanvas = ({
  garmentColor = "#ffffff",
  garmentType = "tshirt",
  activeSide = "front",
  onSideChange,
  onDesignChange,
  artworkUrl,
}) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const fabricRef = useRef(null);
  const [activeObject, setActiveObject] = useState(null);
  const [designStates, setDesignStates] = useState({});
  const [textInput, setTextInput] = useState("");
  const [selectedFont, setSelectedFont] = useState("Arial");
  const [textColor, setTextColor] = useState("#000000");
  const [fontSize, setFontSize] = useState(32);
  const [activeTool, setActiveTool] = useState("select");
  const [canvasSize, setCanvasSize] = useState({ width: 500, height: 560 });
  const lastArtworkRef = useRef(null);

  const isDark = ["#000000", "#1a1a1a", "#1e3a5f", "#2d1b4e", "#1b2d1b", "#4a1c1c", "#333333", "#444444", "#7b241c", "#6c3483"].includes(garmentColor?.toLowerCase());

  /* ── Responsive canvas sizing ── */
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const w = containerRef.current.offsetWidth;
        const h = Math.min(Math.round(w * 1.15), 600);
        setCanvasSize({ width: w, height: h });
      }
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  /* ── Initialize Fabric canvas ── */
  useEffect(() => {
    if (!canvasRef.current) return;
    if (fabricRef.current) {
      fabricRef.current.dispose();
    }

    const c = new Canvas(canvasRef.current, {
      width: canvasSize.width,
      height: canvasSize.height,
      backgroundColor: "transparent",
      selection: true,
      preserveObjectStacking: true,
    });

    c.on("selection:created", (e) => setActiveObject(e.selected?.[0] || null));
    c.on("selection:updated", (e) => setActiveObject(e.selected?.[0] || null));
    c.on("selection:cleared", () => setActiveObject(null));
    c.on("object:modified", () => {
      if (onDesignChange) onDesignChange(c.toJSON(["id", "designType"]));
    });

    fabricRef.current = c;
    return () => { c.dispose(); fabricRef.current = null; };
  }, [canvasSize.width, canvasSize.height]); // eslint-disable-line

  /* ── Draw garment shape + print area ── */
  const drawGarment = useCallback(() => {
    const c = fabricRef.current;
    if (!c) return;

    // Remove old garment elements
    c.getObjects().forEach(obj => {
      if (obj.id === "garment-bg" || obj.id === "garment-shadow" || obj.id === "print-area") {
        c.remove(obj);
      }
    });

    const { width, height } = canvasSize;
    const pathData = GARMENT_PATHS[garmentType] || GARMENT_PATHS.tshirt;
    const pathStr = pathData[activeSide] || pathData.front;

    try {
      // Shadow/depth layer
      const shadowPath = new Path(pathStr, {
        fill: "rgba(0,0,0,0.06)",
        stroke: "transparent",
        selectable: false,
        evented: false,
        id: "garment-shadow",
      });
      const sBounds = shadowPath.getBoundingRect();
      const sPad = Math.min(width, height) * 0.06;
      const sScale = Math.min((width - sPad * 2) / sBounds.width, (height - sPad * 2) / sBounds.height);
      shadowPath.set({
        scaleX: sScale,
        scaleY: sScale,
        left: (width - sBounds.width * sScale) / 2 + 3,
        top: (height - sBounds.height * sScale) / 2 + 4,
      });
      c.add(shadowPath);

      // Garment shape
      const garment = new Path(pathStr, {
        fill: garmentColor || "#ffffff",
        stroke: "#0A0A0A",
        strokeWidth: 2,
        selectable: false,
        evented: false,
        id: "garment-bg",
      });

      const gBounds = garment.getBoundingRect();
      const padding = Math.min(width, height) * 0.06;
      const scale = Math.min((width - padding * 2) / gBounds.width, (height - padding * 2) / gBounds.height);
      const gLeft = (width - gBounds.width * scale) / 2;
      const gTop = (height - gBounds.height * scale) / 2;

      garment.set({
        scaleX: scale,
        scaleY: scale,
        left: gLeft,
        top: gTop,
      });
      c.add(garment);

      // Print area boundary
      const area = PRINT_AREAS[activeSide] || PRINT_AREAS.front;
      const printArea = new Rect({
        left: gLeft + gBounds.width * scale * area.x,
        top: gTop + gBounds.height * scale * area.y,
        width: gBounds.width * scale * area.w,
        height: gBounds.height * scale * area.h,
        fill: "transparent",
        stroke: isDark ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.15)",
        strokeWidth: 1.5,
        strokeDashArray: [6, 4],
        selectable: false,
        evented: false,
        id: "print-area",
      });
      c.add(printArea);

      // Send background layers to back in correct order
      c.sendObjectToBack(printArea);
      c.sendObjectToBack(garment);
      c.sendObjectToBack(shadowPath);
      c.renderAll();
    } catch (err) {
      console.error("Failed to draw garment:", err);
    }
  }, [canvasSize, garmentColor, garmentType, isDark, activeSide]);

  useEffect(() => {
    if (fabricRef.current) drawGarment();
  }, [drawGarment]);

  /* ── Get print area bounds (for centering artwork) ── */
  const getPrintAreaBounds = useCallback(() => {
    const { width, height } = canvasSize;
    const pathData = GARMENT_PATHS[garmentType] || GARMENT_PATHS.tshirt;
    const pathStr = pathData[activeSide] || pathData.front;
    try {
      const temp = new Path(pathStr);
      const gBounds = temp.getBoundingRect();
      const padding = Math.min(width, height) * 0.06;
      const scale = Math.min((width - padding * 2) / gBounds.width, (height - padding * 2) / gBounds.height);
      const gLeft = (width - gBounds.width * scale) / 2;
      const gTop = (height - gBounds.height * scale) / 2;
      const area = PRINT_AREAS[activeSide] || PRINT_AREAS.front;
      return {
        left: gLeft + gBounds.width * scale * area.x,
        top: gTop + gBounds.height * scale * area.y,
        width: gBounds.width * scale * area.w,
        height: gBounds.height * scale * area.h,
      };
    } catch {
      return { left: width * 0.25, top: height * 0.2, width: width * 0.5, height: height * 0.5 };
    }
  }, [canvasSize, garmentType, activeSide]);

  /* ── Load artwork from URL prop ── */
  useEffect(() => {
    const c = fabricRef.current;
    if (!c || !artworkUrl || artworkUrl === lastArtworkRef.current) return;
    lastArtworkRef.current = artworkUrl;

    const bounds = getPrintAreaBounds();
    FabricImage.fromURL(artworkUrl, { crossOrigin: "anonymous" }).then((img) => {
      const maxW = bounds.width * 0.85;
      const maxH = bounds.height * 0.85;
      const sc = Math.min(maxW / img.width, maxH / img.height);
      img.set({
        left: bounds.left + (bounds.width - img.width * sc) / 2,
        top: bounds.top + (bounds.height - img.height * sc) / 2,
        scaleX: sc,
        scaleY: sc,
        id: `artwork-${Date.now()}`,
        designType: "artwork",
        cornerColor: "#f97316",
        cornerStrokeColor: "#ea580c",
        cornerSize: 10,
        transparentCorners: false,
        borderColor: "#f97316",
      });
      c.add(img);
      c.setActiveObject(img);
      c.renderAll();
      if (onDesignChange) onDesignChange(c.toJSON(["id", "designType"]));
    }).catch(err => console.error("Failed to load artwork:", err));
  }, [artworkUrl, getPrintAreaBounds, onDesignChange]);

  /* ── Side switching ── */
  const switchSide = (side) => {
    const c = fabricRef.current;
    if (!c || side === activeSide) return;

    // Save current user objects
    setDesignStates(prev => ({
      ...prev,
      [activeSide]: c.toJSON(["id", "designType"]),
    }));

    // Remove user objects (keep garment + print area)
    c.getObjects().forEach(obj => {
      if (obj.id !== "garment-bg" && obj.id !== "garment-shadow" && obj.id !== "print-area") {
        c.remove(obj);
      }
    });

    if (onSideChange) onSideChange(side);
    c.renderAll();
  };

  /* ── Upload artwork from file ── */
  const handleUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const c = fabricRef.current;
    if (!c) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      FabricImage.fromURL(event.target.result).then((img) => {
        const bounds = getPrintAreaBounds();
        const maxW = bounds.width * 0.85;
        const maxH = bounds.height * 0.85;
        const sc = Math.min(maxW / img.width, maxH / img.height);
        img.set({
          left: bounds.left + (bounds.width - img.width * sc) / 2,
          top: bounds.top + (bounds.height - img.height * sc) / 2,
          scaleX: sc,
          scaleY: sc,
          id: `artwork-${Date.now()}`,
          designType: "artwork",
          cornerColor: "#f97316",
          cornerStrokeColor: "#ea580c",
          cornerSize: 10,
          transparentCorners: false,
          borderColor: "#f97316",
        });
        c.add(img);
        c.setActiveObject(img);
        c.renderAll();
        if (onDesignChange) onDesignChange(c.toJSON(["id", "designType"]));
      });
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  /* ── Add text ── */
  const addText = () => {
    const c = fabricRef.current;
    if (!c || !textInput.trim()) return;
    const bounds = getPrintAreaBounds();
    const text = new Textbox(textInput, {
      left: bounds.left + bounds.width * 0.1,
      top: bounds.top + bounds.height * 0.4,
      width: bounds.width * 0.8,
      fontSize,
      fontFamily: selectedFont,
      fill: textColor,
      textAlign: "center",
      id: `text-${Date.now()}`,
      designType: "text",
      cornerColor: "#f97316",
      cornerStrokeColor: "#ea580c",
      cornerSize: 10,
      transparentCorners: false,
      borderColor: "#f97316",
    });
    c.add(text);
    c.setActiveObject(text);
    c.renderAll();
    setTextInput("");
    setActiveTool("select");
    if (onDesignChange) onDesignChange(c.toJSON(["id", "designType"]));
  };

  /* ── Object actions ── */
  const deleteSelected = () => {
    const c = fabricRef.current;
    if (!c || !activeObject) return;
    c.remove(activeObject);
    setActiveObject(null);
    c.renderAll();
    if (onDesignChange) onDesignChange(c.toJSON(["id", "designType"]));
  };

  const flipH = () => { if (activeObject) { activeObject.set("flipX", !activeObject.flipX); fabricRef.current?.renderAll(); } };
  const flipV = () => { if (activeObject) { activeObject.set("flipY", !activeObject.flipY); fabricRef.current?.renderAll(); } };
  const bringForward = () => { if (activeObject && fabricRef.current) { fabricRef.current.bringObjectForward(activeObject); fabricRef.current.renderAll(); } };
  const sendBackward = () => { if (activeObject && fabricRef.current) { fabricRef.current.sendObjectBackwards(activeObject); fabricRef.current.renderAll(); } };

  const sides = garmentType === "hat"
    ? [{ id: "front", label: "Front" }, { id: "back", label: "Back" }]
    : [
        { id: "front", label: "Front" },
        { id: "back", label: "Back" },
        { id: "left_side", label: "Left Side" },
        { id: "right_side", label: "Right Side" },
      ];

  return (
    <div className="flex flex-col gap-2" data-testid="design-canvas-container">
      {/* Side tabs */}
      <div className="flex border-2 border-ink" data-testid="side-tabs">
        {sides.map((s, i) => (
          <button
            key={s.id}
            onClick={() => switchSide(s.id)}
            className={`flex-1 font-mono text-[10px] uppercase tracking-[0.1em] font-bold py-1.5 transition-all ${i > 0 ? "border-l-2 border-ink" : ""} ${
              activeSide === s.id
                ? "bg-ink text-acid"
                : "bg-bone text-ink hover:bg-stock"
            }`}
            data-testid={`side-tab-${s.id}`}
          >
            {s.label}
          </button>
        ))}
      </div>

      {/* Canvas area */}
      <div
        ref={containerRef}
        className="relative overflow-hidden border-2 border-ink"
        style={{
          minHeight: 280,
          background: "#EBE4D2",
        }}
        data-testid="canvas-wrapper"
      >
        <canvas ref={canvasRef} data-testid="fabric-canvas" />
        {/* Print area label overlay */}
        <div className="absolute top-2 left-2 bg-ink text-acid font-mono text-[9px] uppercase tracking-[0.1em] font-bold px-2 py-1 border border-ink pointer-events-none">
          {(PRINT_AREAS[activeSide] || PRINT_AREAS.front).label} Print Area
        </div>
        {/* Drag hint */}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-ink text-paper font-mono text-[9px] uppercase tracking-[0.08em] px-2 py-1 pointer-events-none">
          <Move className="w-3 h-3" /> Drag to position
        </div>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap gap-0 border-2 border-ink" data-testid="canvas-toolbar">
        <button
          className={`h-8 px-3 font-mono text-[10px] uppercase tracking-[0.08em] font-bold transition ${activeTool === "select" ? "bg-ink text-acid" : "bg-bone text-ink hover:bg-stock"}`}
          onClick={() => setActiveTool("select")}
          data-testid="tool-select"
        >
          <MousePointer className="w-3.5 h-3.5 inline mr-1" />Select
        </button>

        <div className="relative border-l-2 border-ink">
          <button className="h-8 px-3 font-mono text-[10px] uppercase tracking-[0.08em] font-bold bg-bone text-ink hover:bg-stock" data-testid="tool-upload">
            <Upload className="w-3.5 h-3.5 inline mr-1" />Upload Art
          </button>
          <input type="file" accept="image/*,.svg" onChange={handleUpload} className="absolute inset-0 opacity-0 cursor-pointer" data-testid="canvas-file-input" />
        </div>

        <button
          className={`h-8 px-3 font-mono text-[10px] uppercase tracking-[0.08em] font-bold border-l-2 border-ink transition ${activeTool === "text" ? "bg-ink text-acid" : "bg-bone text-ink hover:bg-stock"}`}
          onClick={() => setActiveTool(activeTool === "text" ? "select" : "text")}
          data-testid="tool-text"
        >
          <Type className="w-3.5 h-3.5 inline mr-1" />Add Text
        </button>

        {activeObject && (
          <>
            <div className="w-0.5 h-8 bg-ink" />
            <button className="h-8 px-2 bg-signal text-bone border-l-2 border-ink font-mono text-[10px]" onClick={deleteSelected} data-testid="tool-delete">
              <Trash2 className="w-3.5 h-3.5" />
            </button>
            <button className="h-8 px-2 bg-bone text-ink border-l-2 border-ink" onClick={flipH} data-testid="tool-flip-h">
              <FlipHorizontal className="w-3.5 h-3.5" />
            </button>
            <button className="h-8 px-2 bg-bone text-ink border-l-2 border-ink" onClick={flipV} data-testid="tool-flip-v">
              <FlipVertical className="w-3.5 h-3.5" />
            </button>
            <button className="h-8 px-2 bg-bone text-ink border-l-2 border-ink" onClick={bringForward} data-testid="tool-forward">
              <Layers className="w-3.5 h-3.5" />
            </button>
            <button className="h-8 px-2 bg-bone text-ink border-l-2 border-ink" onClick={sendBackward} data-testid="tool-backward">
              <RotateCw className="w-3.5 h-3.5" />
            </button>
          </>
        )}
      </div>

      {/* Text input panel */}
      {activeTool === "text" && (
        <div className="bg-stock border-2 border-ink p-3 space-y-2" data-testid="text-panel">
          <div className="flex gap-0">
            <Input
              value={textInput}
              onChange={(e) => setTextInput(e.target.value)}
              placeholder="Enter your text..."
              className="flex-1 h-8 text-sm bg-bone border-2 border-ink rounded-none font-inter"
              data-testid="text-input"
              onKeyDown={(e) => e.key === "Enter" && addText()}
            />
            <Button size="sm" className="h-8 font-mono text-[10px] uppercase tracking-wider font-bold bg-signal text-bone border-2 border-ink rounded-none hover:bg-ink hover:text-acid" onClick={addText} data-testid="add-text-btn">
              Add
            </Button>
          </div>
          <div className="flex flex-wrap gap-2 items-center">
            <select
              value={selectedFont}
              onChange={(e) => {
                setSelectedFont(e.target.value);
                if (activeObject?.type === "textbox") {
                  activeObject.set("fontFamily", e.target.value);
                  fabricRef.current?.renderAll();
                }
              }}
              className="h-7 px-2 text-xs border rounded bg-white"
              data-testid="font-select"
            >
              {FONTS.map(f => <option key={f} value={f} style={{ fontFamily: f }}>{f}</option>)}
            </select>
            <Input
              type="number"
              value={fontSize}
              onChange={(e) => {
                const v = parseInt(e.target.value) || 24;
                setFontSize(v);
                if (activeObject?.type === "textbox") { activeObject.set("fontSize", v); fabricRef.current?.renderAll(); }
              }}
              className="w-16 h-7 text-xs text-center"
              min="8"
              max="120"
              data-testid="font-size"
            />
            <input
              type="color"
              value={textColor}
              onChange={(e) => {
                setTextColor(e.target.value);
                if (activeObject?.type === "textbox") { activeObject.set("fill", e.target.value); fabricRef.current?.renderAll(); }
              }}
              className="w-7 h-7 rounded cursor-pointer border"
              data-testid="text-color"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DesignCanvas;
